import { TEST_PREVIEW } from "../actions/types";
import { PREVIEW_PROGRESS } from "../actions/constants";
import { getPreviewSkipStorageKey } from "../utills/common";

const initialState = {
  time: 0,
  error: null,
  taskIndex: 0,
  loading: false,
  progress: null,
  testDetails: null,
  testResults: null,
  isScreener: null,
  screenerSetId: null,
  screenerDraftId: null,
  screenerResponseId: null,
  lang: null,
  countries: [],
  testStartedAt: null,
  // skipToTask: false,
};

const testpreviewReducer = (state = initialState, action) => {
  const { type, payload, widgetMeta = null, testId = null } = action;

  switch (type) {
    case TEST_PREVIEW.LOAD: {
      const { isWidget = false, widgetTaskIndex = null } = widgetMeta || {};
      const isSkipTrue = JSON.parse(localStorage.getItem(getPreviewSkipStorageKey(testId)) || "false");

      return {
        ...initialState,
        testDetails: payload,
        progress: isSkipTrue ? PREVIEW_PROGRESS.TASK_DETAILS : isWidget ? PREVIEW_PROGRESS.TASK_DETAILS : PREVIEW_PROGRESS.SCREENER,
        loading: false,
        taskIndex: isWidget && widgetTaskIndex > 0 ? widgetTaskIndex : 0,
      };
    }

    case TEST_PREVIEW.UPDATE:
      return { ...state, ...payload };

    case TEST_PREVIEW.ERROR:
      return { ...state, error: payload, loading: false };

    default:
      return state;
  }
};

export default testpreviewReducer;
